import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function initHorizontalScrollCards() {
  const carouselContainers = document.querySelectorAll('.cmp-horizontalscrollcards');

  carouselContainers.forEach((carouselContainer) => {
    const swiperEl = carouselContainer.querySelector('.swiper');
    const paginationEl = carouselContainer.querySelector('.swiper-pagination');

    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      slidesPerGroup: 1,
      watchOverflow: false,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });
}
